// extracted by mini-css-extract-plugin
module.exports = {"container":"lpAuh","postMainActionContainer":"_3gEON","icon":"_1oSjM","wrapper":"_1yDTs","postPageRevamp":"_1mi6f","postMainActionWrapper":"_1DLFP"};